// extracted by mini-css-extract-plugin
export default {"customScrollBar":"components_customScrollBar__WUFFu"};